// extracted by mini-css-extract-plugin
module.exports = {"container":"DesktopCta_container__aiImV","title":"DesktopCta_title__luSyR","subtitle":"DesktopCta_subtitle__rsVmd","gutters":"DesktopCta_gutters__fveij"};